export enum CreatorStep {
	CONFIGURATION,
	PERSONALIZATION,
}

export enum ViewType {
	'2D' = '2D',
	'3D' = '3D',
}

export enum LayerType {
	INTERNAL = 'INTERNAL',
	EXTERNAL = 'EXTERNAL',
}

export interface CreatorOptions {
	isProductTypeInfoOpened: boolean;
	currentStep: CreatorStep;
	viewType: ViewType;
	layerType: LayerType;
	isSideView: boolean;
	selectedDecor: string | null;
}

export interface CreatorRendererOptions {}

export interface CreatorState {
	options: CreatorOptions;
}
